import { BaseServices } from './BaseServices';
import { DnGroupApiGatewayClient} from '../public-clients';

class UserServices extends BaseServices {
  constructor(config) {
    super(config);
    this.dnGroupApiGatewayConfig = this.config.dnGroupApiGatewayConfig || {};
    this.dnGroupApiGatewayClient = new DnGroupApiGatewayClient(this.dnGroupApiGatewayConfig);
  }

  async getSegmentsByOneIdAndDomain(oneId, domain) {
    return this.dnGroupApiGatewayClient.getSegmentsByOneIdAndDomain(oneId, domain);
  }
}

export { UserServices };
